<ig-field #trigger [label]="label" [icon]="icon" [isReadOnly]="true" [(ngModel)]="fieldValue" [disabled]="disabled"
    [control]="formGroup.get('input')">
</ig-field>

<div class="drop-down-container shadow-md" #container [class.show]="isShowing">
    <div item *ngFor="let item of value" (click)="select(item)">{{item.text}}</div>
</div>